import React from "react";
import { Link } from "react-router-dom";
import { MONOGRAM } from "@/data/site";

export function Logo({ compact = false, className = "" }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`flex items-center gap-3 group ${className}`}>
      <img src={MONOGRAM} alt="HYEAMAN monogram"
        className="h-9 w-auto sm:h-10 object-contain" />
      {!compact && (
        <span className="hidden sm:flex flex-col leading-none">
          <span className="font-serif text-lg tracking-[0.3em] text-cream">HYEAMAN</span>
          <span className="mt-1 font-mono text-[0.5rem] uppercase tracking-[0.4em] text-gold/70">Street Sheriff</span>
        </span>
      )}
    </Link>
  );
}
